import Grow from '@material-ui/core/Grow';
import Modal from '@material-ui/core/Modal';
export const ModalCustom = ({
  open,
  onClose,
  children,
  className,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <Modal
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      open={!!open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Grow in={!!open} timeout={500}>
        <div
          style={{
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            borderRadius: '20px',
            border: '1px solid silver',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)',
            outline: 'none',
            maxHeight: '90vh',
            maxWidth: '90vw',
            width: 'auto',
            minWidth: '350px',
          }}
          className={className}
        >
          <div
            id={'modal-container'}
            style={{
              overflowY: 'auto',
              overflowX: 'hidden',
              maxHeight: '90vh',
            }}
          >
            {children}
          </div>
        </div>
      </Grow>
    </Modal>
  );
};

export default ModalCustom;
